import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "offcanvas offcanvas-bottom h-100 bg-primary-grasient",
  id: "MagicRemoteJoystick",
  "aria-labelledby": "MagicRemoteJoystick",
  ref: "MagicRemoteJoystick",
  "data-bs-scroll": "true"
}
const _hoisted_2 = { class: "offcanvas-header d-block container-lg" }
const _hoisted_3 = {
  class: "offcanvas-title text-center fs-4",
  id: "MagicRemoteJoystick"
}
const _hoisted_4 = { class: "offcanvas-body d-flex align-items-center" }
const _hoisted_5 = { class: "w-100 container-lg" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 col-md-4" }
const _hoisted_8 = { class: "row gx-3" }
const _hoisted_9 = { class: "col-6 ps-0" }
const _hoisted_10 = { class: "col-6 pe-0" }
const _hoisted_11 = { class: "row gx-3 mt-5" }
const _hoisted_12 = { class: "col-6 text-center" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "my-5" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "col-6 text-center" }
const _hoisted_17 = { class: "col-12 col-md-4 d-flex align-items-center justify-content-center" }
const _hoisted_18 = { class: "col-12 col-md-4" }
const _hoisted_19 = { class: "row gx-3" }
const _hoisted_20 = { class: "col-6 ps-0" }
const _hoisted_21 = { class: "col-6 pe-0" }
const _hoisted_22 = { class: "nav-ring m-auto mt-5 bg-secondary bg-opacity-05" }
const _hoisted_23 = { class: "col-12 mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BtnHome = _resolveComponent("BtnHome")!
  const _component_healper = _resolveComponent("healper")!
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_MagicRemoteMultimadia = _resolveComponent("MagicRemoteMultimadia")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_healper, { onBack: _ctx.closeOffcanvas }, {
        right: _withCtx(() => [
          _createVNode(_component_BtnHome, {
            onGohome: _cache[0] || (_cache[0] = ($event: any) => {
              _ctx.closeOffcanvas();
              _ctx.$router.replace({ name: 'home' });
            })
          })
        ]),
        _: 1
      }, 8, ["onBack"]),
      _withDirectives(_createElementVNode("p", _hoisted_3, null, 512), [
        [_directive_t, 'magic_remote.ksk']
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "btn btn-secondary bg-secondary bg-opacity-05 border-0 w-100 d-flex align-items-center justify-content-center",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sendNewCommand('mute', '', 'volume_control')))
                }, [
                  _createVNode(_component_IconComponent, {
                    lib: 'material',
                    icon: 'volume_off'
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("button", {
                  class: "btn btn-secondary bg-secondary bg-opacity-05 border-0 w-100",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendNewCommand('button', 'TV-guide')))
                }, null, 512), [
                  [_directive_t, 'magic_remote.buttons.tv-guide']
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  class: "btn btn-secondary bg-secondary bg-opacity-05 square-joystick-btn",
                  onMousedown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.startDecrement(1))),
                  onMouseup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.stopAction && _ctx.stopAction(...args))),
                  onMouseleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.stopAction && _ctx.stopAction(...args))),
                  onTouchend: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.stopAction && _ctx.stopAction(...args))),
                  onTouchcancel: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.stopAction && _ctx.stopAction(...args))),
                  disabled: _ctx.volume === 100
                }, [...(_cache[24] || (_cache[24] = [
                  _createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1)
                ]))], 40, _hoisted_13),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_IconComponent, {
                    lib: 'material',
                    icon: 'volume_up'
                  })
                ]),
                _createElementVNode("button", {
                  class: "btn btn-secondary bg-secondary bg-opacity-05 square-joystick-btn",
                  onMousedown: _cache[8] || (_cache[8] = ($event: any) => (_ctx.startDecrement(-1))),
                  onMouseup: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.stopAction && _ctx.stopAction(...args))),
                  onMouseleave: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.stopAction && _ctx.stopAction(...args))),
                  onTouchend: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.stopAction && _ctx.stopAction(...args))),
                  onTouchcancel: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.stopAction && _ctx.stopAction(...args))),
                  disabled: _ctx.volume === 0
                }, [...(_cache[25] || (_cache[25] = [
                  _createElementVNode("i", { class: "bi bi-dash-lg" }, null, -1)
                ]))], 40, _hoisted_15)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  class: "btn btn-secondary bg-secondary bg-opacity-05 square-joystick-btn",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sendNewCommand('button', 'ch-up')))
                }, [...(_cache[26] || (_cache[26] = [
                  _createElementVNode("i", { class: "bi bi-chevron-up" }, null, -1)
                ]))]),
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "my-5" }, "P", -1)),
                _createElementVNode("button", {
                  class: "btn btn-secondary bg-secondary bg-opacity-05 square-joystick-btn",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.sendNewCommand('button', 'ch-down')))
                }, [...(_cache[27] || (_cache[27] = [
                  _createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1)
                ]))])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              class: "btn btn-secondary bg-secondary bg-opacity-05 border-0 d-flex align-items-center justify-content-center square-joystick-btn",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sendNewCommand('button', 'power')))
            }, [...(_cache[29] || (_cache[29] = [
              _createElementVNode("i", { class: "bi bi-power fs-3" }, null, -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "btn btn-secondary bg-secondary bg-opacity-05 border-0 w-100 d-flex align-items-center justify-content-center",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.sendNewCommand('button', 'back')))
                }, [
                  _createVNode(_component_IconComponent, {
                    lib: 'filoxenia',
                    icon: 'ArrowBack',
                    class: "me-2"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("buttons.back")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("button", {
                  class: "btn btn-secondary bg-secondary bg-opacity-05 border-0 w-100",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.sendNewCommand('button', 'home')))
                }, null, 512), [
                  [_directive_t, 'buttons.stop']
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                class: "btn bg-transparent square-joystick-btn nav-btn up",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.sendNewCommand('button', 'up')))
              }, [...(_cache[30] || (_cache[30] = [
                _createElementVNode("i", { class: "bi bi-caret-up-fill" }, null, -1)
              ]))]),
              _createElementVNode("button", {
                class: "btn bg-transparent square-joystick-btn nav-btn left",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sendNewCommand('button', 'left')))
              }, [...(_cache[31] || (_cache[31] = [
                _createElementVNode("i", { class: "bi bi-caret-left-fill" }, null, -1)
              ]))]),
              _createElementVNode("button", {
                class: "nav-btn ok",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.sendNewCommand('button', 'ok')))
              }, " OK "),
              _createElementVNode("button", {
                class: "btn bg-transparent square-joystick-btn nav-btn right",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.sendNewCommand('button', 'right')))
              }, [...(_cache[32] || (_cache[32] = [
                _createElementVNode("i", { class: "bi bi-caret-right-fill" }, null, -1)
              ]))]),
              _createElementVNode("button", {
                class: "btn bg-transparent square-joystick-btn nav-btn down",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.sendNewCommand('button', 'down')))
              }, [...(_cache[33] || (_cache[33] = [
                _createElementVNode("i", { class: "bi bi-caret-down-fill" }, null, -1)
              ]))])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_MagicRemoteMultimadia, {
              onMovieControl: _cache[23] || (_cache[23] = ($event: any) => (
                _ctx.sendNewCommand($event.type, $event.value, $event.command, $event.property)
              ))
            })
          ])
        ])
      ])
    ])
  ], 512))
}